import React, { Component } from "react";
import Styled from "styled-components";

import SubTitle from "./SubTitle";

class Hero extends Component {
  render() {
    const Title = Styled.p`
			font-size: 5.5em;
			font-family: 'Bree Serif', serif;
			color: Tomato;

			@media (max-width: 700px) {
				font-size: 2.5em;
			}
			`;

    const Link = Styled.a`
			font-size: 2.5em;
      color: #D3D3D3;
			&:hover {
				color: Tomato;
      }
      
      @media (max-width: 700px) {
				font-size: 1.5em;
			}
	`;

    const Hero = Styled.div`
			display: flex;
			flex-direction: column;
			justify-content: center;
			align-items: center;
			background: #0f0c29;
			background: -webkit-linear-gradient(to right, #24243e, #302b63, #0f0c29);
			background: linear-gradient(to right, #24243e, #302b63, #0f0c29);
			`;

    return (
      <Hero>
        <div>
          <Link href="https://www.linkedin.com/in/jn-perez/" target="_blank">
            <i className="fab fa-linkedin-in fa-fw" />
          </Link>
          <Link href="https://github.com/che-perez" target="_blank">
            <i className="fab fa-github-square fa-fw" />
          </Link>
          <Link href="mailto:che.perez3@gmail.com">
            <i className="far fa-envelope fa-fw" />
          </Link>
        </div>
        <Title>Josué Pérez</Title>
        <SubTitle />
      </Hero>
    );
  }
}

export default Hero;



// WEBPACK FOOTER //
// ./src/Components/Hero.jsx